import React from 'react';
import styled from 'styled-components';

import { ReactComponent as FabricIcon } from '@/assets/svg/fabric.svg';

import Button from './Button';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
};

function FabricButton({ children, onClick, ...rest }: Props) {
  return (
    <Button onClick={onClick} {...rest} variant={'outlined-primary-w100-f14'}>
      {children}
      <StyledIcon />
    </Button>
  );
}

export default FabricButton;

const StyledIcon = styled(FabricIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
`;
